<div
  class="overlay"
  (click)="hideOverlay()"
  [style.background]="background"
></div>
